import { Database, CheckCircle, AlertCircle, Clock } from 'lucide-react';

export const DataHealthCard = ({ dataHealth }) => {
  const total = dataHealth.length;
  const live = dataHealth.filter(d => d.status === 'live').length;
  const partial = dataHealth.filter(d => d.status === 'partial').length;
  const setup = dataHealth.filter(d => d.status === 'setup').length;

  return (
    <div className="mb-8 border border-gray-800 rounded-lg overflow-hidden" data-testid="data-health-card">
      <div className="bg-black/60 px-6 py-4 flex items-center justify-between border-b border-gray-800">
        <div className="flex items-center gap-3">
          <Database className="w-5 h-5 text-[#00d1ff]" />
          <h2 className="text-sm font-semibold text-[#00d1ff] uppercase tracking-wider">Data Pipeline Health</h2>
        </div>
        <div className="flex items-center gap-4 text-xs">
          <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-[#00ff41]" /><span className="text-gray-400">{live} Live</span></span>
          {partial > 0 && <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-yellow-500" /><span className="text-gray-400">{partial} Partial</span></span>}
          {setup > 0 && <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full bg-[#ff0033]" /><span className="text-gray-400">{setup} Needs Setup</span></span>}
          <span className="text-gray-600">|</span>
          <span className="text-gray-400">{live}/{total} sources connected</span>
        </div>
      </div>
      <div className="grid grid-cols-3 md:grid-cols-5 lg:grid-cols-10 divide-x divide-gray-800 border-t border-gray-800 lg:border-t-0">
        {dataHealth.map((source) => (
          <div
            key={source.name}
            className={`px-4 py-3 bg-black/30 hover:bg-black/50 transition-colors ${source.apis ? 'col-span-3 md:col-span-2 lg:col-span-2' : ''}`}
            data-testid={`health-${source.id}`}
          >
            {source.apis ? (
              <ApiSubsCell apis={source.apis} />
            ) : (
              <>
                <div className="flex items-center gap-2 mb-1">
                  <StatusDot status={source.status} />
                  <span className="text-xs font-medium text-white truncate">{source.name}</span>
                </div>
                <p className="text-[10px] text-gray-500 ml-4">{source.detail}</p>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const ApiSubsCell = ({ apis }) => (
  <>
    <div className="flex items-center gap-2 mb-2">
      <Database className="w-3 h-3 text-[#00d1ff] flex-shrink-0" />
      <span className="text-xs font-medium text-white">API Subs</span>
    </div>
    <div className="grid grid-cols-3 gap-x-2 gap-y-1">
      {apis.map((api) => (
        <div key={api.sport} className="flex items-center gap-1">
          <span className={`w-2 h-2 rounded-full flex-shrink-0 ${api.status === 'live' ? 'bg-[#00ff41]' :
            api.status === 'setup' ? 'bg-orange-500' :
              api.status === 'planned' ? 'bg-gray-600' :
                'bg-[#ff0033]'
            }`} />
          <span className={`text-[9px] truncate ${api.status === 'planned' ? 'text-gray-600' : 'text-gray-500'}`}>{api.sport}</span>
        </div>
      ))}
    </div>
  </>
);

const StatusDot = ({ status }) => {
  if (status === 'live') return <CheckCircle className="w-3 h-3 text-[#00ff41] flex-shrink-0" />;
  if (status === 'partial') return <Clock className="w-3 h-3 text-yellow-500 flex-shrink-0" />;
  return <AlertCircle className="w-3 h-3 text-[#ff0033] flex-shrink-0" />;
};
